const DAY_SECOND = 86400;

/**
 * [判断空对象]
 * @param {[object]} obj
 * @return {[boolean]}
 */
export const isEmptyObject = obj => JSON.stringify(obj) === '{}';

/**
 * 从url中获取参数值
 * @param {string} 参数名
 * @return {string} 参数值
 * @author lichun 正则自己写的，不保证所有情况下都正确 ^-^ 凑合着用
 */
export const getQueryString = (name) => {
  const reg = new RegExp(`([?&])${name}=([^&]*?)(#|&|$)`, 'i');
  const r = window.location.href.match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return '';
};

/**
 * [设置cookie]
 * @param {[string]} cookie key
 * @param {[string]} cookie value
 * @author lichun
 */
export const setCookie = (name, value) => {
  const now = new Date();
  now.setDate(now.getDate() + 1000 * 60 * 60 * 24 * 30);
  const str = `${name}=${value};expires=${now.toGMTString()};path=/;`;
  document.cookie = str;
};

/**
 * [得到cookie]
 * @param {[string]} cookie key
 * @returns {[string]} value
 * @author lichun
 */
export const getCookie = (name) => {
  let start;
  let end;

  if (document.cookie.length > 0) {
    start = document.cookie.indexOf(`${name}=`);

    if (start !== -1) {
      start = start + name.length + 1;
      end = document.cookie.indexOf(';', start);
      if (end === -1) {
        end = document.cookie.length;
      }
      return unescape(document.cookie.substring(start, end));
    }
  }
  return '';
};

/**
 * 节流函数
 * @param {*} fn
 * @param {*} delay
 */
export const throttle = (fn, delay) => {
  let timer = null;

  return (params) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn(params);
    }, delay);
  };
};

export const checkCoordinate = coordinate =>
  coordinate &&
  coordinate.length === 2 &&
  parseInt(coordinate[0], 10) &&
  parseInt(coordinate[1], 10);

const fixedToTwo = (num) => {
  if (num < 100) {
    return `0${num}`.substr(-2);
  }
  return num;
};

export const getDayTimeByTimestamp = (timestamp) => {
  if (timestamp) {
    const fullSecond = (timestamp + 28800) % DAY_SECOND;
    const hour = Math.floor(fullSecond / 3600);
    // eslint-disable-next-line
    const minute = Math.floor((fullSecond % 3600) / 60);
    const second = (fullSecond % 3600) % 60;

    return `${fixedToTwo(hour)}:${fixedToTwo(minute)}:${fixedToTwo(second)}`;
  }
  return '00:00:00';
};

/**
 * [日期转化工具]
 * @param  {[date]} dateobj [日期对象]
 * @param  {[string]} format [转化格式 yyyy-MM-dd hh:mm:ss]
 * @return {[string]}
 * @author lichun
 */
export const formatDate = (dateobj, format = 'yyyy-MM-dd') => {
  const date = {
    'M+': dateobj.getMonth() + 1,
    'd+': dateobj.getDate(),
    'h+': dateobj.getHours(),
    'm+': dateobj.getMinutes(),
    's+': dateobj.getSeconds(),
    'q+': Math.floor((dateobj.getMonth() + 3) / 3),
    'S+': dateobj.getMilliseconds(),
  };
  if (/(y+)/i.test(format)) {
    format = format.replace(
      RegExp.$1,
      `${dateobj.getFullYear()}`.substr(4 - RegExp.$1.length),
    );
  }
  // eslint-disable-next-line
  for (let k in date) {
    if (new RegExp(`(${k})`).test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1
          ? date[k]
          : `00${date[k]}`.substr(`${date[k]}`.length),
      );
    }
  }
  return format;
};

export const strToDate = (dateString) => {
  const year = dateString.substring(0, 4);
  const month = dateString.substring(4, 6);
  const day = dateString.substring(6, 8);
  return new Date(year, month - 1, day);
};

export const formatDateStr = (dateString, symbol = '-') => {
  const year = dateString.substring(0, 4);
  const month = dateString.substring(4, 6);
  const day = dateString.substring(6, 8);
  return `${year}${symbol}${month}${symbol}${day}`;
};

export const timeNow = () => {
  // 配合后端 时间戳10位
  let tmp = Date.parse(new Date()).toString();
  tmp = tmp.substr(0, 10);
  return tmp;
};

export const getDateByTimestamp = (timestamp) => {
  if (timestamp) {
    const date = new Date(timestamp * 1000);
    return formatDate(date, 'yyyyMMdd');
  }
  return timestamp;
};

export const getTimestampByRoute = () => {
  let timestamp = 86400;
  const hashs = location.hash.split('/');
  if (hashs.length && hashs[hashs.length - 1].length > 0) {
    timestamp = parseInt(hashs[hashs.length - 1], 10); // 1519869655
  } else {
    timestamp = timeNow();
  }
  return timestamp;
};

export const getDateByRoute = () => {
  const timestamp = getTimestampByRoute();
  return getDateByTimestamp(timestamp);
};

export const getRiderIdByRoute = () => {
  let riderId = '';
  const hashs = location.hash.split('/');
  if (hashs.length && hashs.length > 1) {
    riderId = parseInt(hashs[hashs.length - 2], 10);
  }
  return riderId;
};

/**
 * 判断品牌
 */

const getBrand = () => {
  const { hostname } = window.location;
  let brand = '';
  switch (hostname) {
    case 'phdelivery.yumchina.com':
      brand = 'PH';
      break;
    case 'uphdelivery.yumchina.com':
      brand = 'UPH';
      break;
    case 'delivery.yumchina.com':
      brand = '百胜';
      break;
    default:
      brand = '百胜';
      break;
  }
  return brand;
};
export const brand = getBrand();
// 根据host判断必胜客orKFC，修改favicon
const link =
  document.querySelector("link[rel*='icon']") || document.createElement('link');
link.type = 'image/x-icon';
link.rel = 'shortcut icon';
link.href = brand === '百胜' ? '/static/traveller/yum_logo_mini.ico' : '/static/traveller/ph_favicon.ico';
document.getElementsByTagName('head')[0].appendChild(link);

/**
 * 获取KFC日期，5：00到5：00，例如2017-5-5 17:33 => 2017-5-5； 2017-5-5 01:33 => 2017-5-4
 * timestamp unix时间戳
 */
export const getKFCDate = (timestamp) => {
  const date = new Date((timestamp - 5 * 3600) * 1000);
  return formatDate(date);
};



// WEBPACK FOOTER //
// ./src/common/utils.js